var serverlessVercelNodeJsConfig = {
  environment: {},
  runtime: "nodejs20.x",
  handler: "entrypoint/index.js",
  launcherType: "Nodejs",
  shouldAddHelpers: true,
  shouldAddSourceMapSupport: true
};
export {
  serverlessVercelNodeJsConfig
};
//# sourceMappingURL=vc-config-base.js.map
